<template>
  <app-card
    class="active"
    :show-header="false"
    :show-footer="false"
  >
    <template #text>
      <ValidationObserver
        v-slot="{ invalid }"
        ref="form"
      >
        <b-form>
          <b-form-group>
            <app-label :editable="false" icon-class="fal fa-paperclip">
              <a target="_blank" :href="attachment.link">{{attachment.fileName}}</a>
            </app-label>
          </b-form-group>
          <b-form-group :label="$t('Description')">
            <b-form-input
              v-model="description"
              :placeholder="$t('Description')"
              size="lg"
              type="text"
            />
          </b-form-group>
          <div class="d-flex justify-content-end">
            <app-button
              size="sm"
              class="mar-r-2"
              variant="outline-secondary"
              @click.prevent="onCancelClick"
            >
              {{$t('Cancel')}}
            </app-button>
            <app-button
              size="sm"
              type="submit"
              :disabled="invalid"
              variant="primary"
              @click.prevent="onSaveClick"
            >
              {{$t('Save')}}
            </app-button>
          </div>
        </b-form>
      </ValidationObserver>
    </template>
  </app-card>
</template>

<script>
import AppCard from '@/components/htmlHelpers/AppCard'
import { ValidationObserver } from 'vee-validate'
import AppButton from '@/components/htmlHelpers/AppButton'
import AppLabel from '@/components/htmlHelpers/AppLabel'
import BaseComponent from '@/components/commentsNew/BaseComponent'
export default {
  name: 'AttachmentEditFileForm',
  extends: BaseComponent,
  components: {
    AppLabel,
    AppButton,
    AppCard,
    ValidationObserver
  },
  props: {
    attachment: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      description: ''
    }
  },
  created () {
    this.description = this.attachment.attachmentName
  },
  methods: {
    onCancelClick () {
      this.$emit('cancel')
    },
    onSaveClick () {
      this.$emit('save', this.description)
    }
  }
}
</script>

<style scoped>

</style>
